import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

import Box from "../../widgets/Box/Box";
import Logo from "./Logo";
import ProfileMenu from "./Profile/ProfileMenu";
import ProfileModal from "./Profile/ProfileModal";
import routes from "../../constants/routes";

import headerStyles from "./header.module.scss";
import boxStyles from "../../widgets/Box/box.module.scss";

const Header = () => {
  const navigate = useNavigate();

  const [profileOpen, setProfileOpen] = useState(false);

  const handleViewProfile = () => {
    setProfileOpen(true);
  };

  const handleCloseProfile = () => {
    setProfileOpen(false);
  };

  return (
    <>
      <AppBar position="static" elevation={0} className={headerStyles.header}>
        <Toolbar className={headerStyles.headerToolbar}>
          <Box
            className={boxStyles.headerLogo}
            onClick={() => navigate(routes.manageStudent.root)}
          >
            <Logo />
          </Box>

          <Typography
            component="h1"
            className={headerStyles.headerTitle}
          >
            Admin Support Dashboard
          </Typography>

          <Box className={boxStyles.headerFlexSpacer} />

          <ProfileMenu
            onViewProfile={handleViewProfile}
          />
        </Toolbar>
      </AppBar>

      <ProfileModal open={profileOpen} onClose={handleCloseProfile} />
    </>
  );
};

export default Header;
